exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#forgot-box{\n    width: 250px;\n    margin: auto;\n    text-align: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/mmam/angular/src/app/forgot/forgot.component.css
// module id = ../../../../../src/app/forgot/forgot.component.css
// module chunks = main